<template>
	<div>
		<!-- 店铺详情 -->
		<cube-page title="分销商" :backurl="'/My'">
			<div slot="content">
				<div class="nodata">
					<div class="title">
						您已注册智慧旅游
					</div>
					<div class="btns">
						<div @click="goIndex">同业中心</div>
						<div @click="goAppr">资料修改</div>
					</div>
				</div>
			</div>
		</cube-page>
	</div>
</template>

<script>
	import CubePage from '../../TP/cube-page.vue'
	import * as util from '@/utils/network'
	export default {
		components: {
			CubePage
		},
		data() {
			return {
				isTure: false
			}
		},
		methods: {
			goIndex() {
				this.$router.push({
					name: 'Distributor'
				})
			},
			goAppr() {
				this.$router.push({
					name: 'DistributorAppr'
				})
			},
			getData() {
				let that = this;
				var url = "/addons/litestore/api.account/editDistributor"
				//这里直接调用网络接口
				util.get(url, {},
					function(result) {
						if (result.data != null) {
							that.isTure = true
						}else{
							that.goAppr() 
						}
					},
				);
			},

		},
		created() {
			this.getData()
		}
	}
</script>
<style type="text/css" lang="less">
	.nodata {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		.title {
			padding: 120px 0 50px 0;
			color: orangered;
		}

		.btns {
			display: flex;

			div {
				padding: 0 20px;
				color: #00aaff;
				font-size: 14px;
			}
		}
	}
</style>
